export default __webpack_public_path__ + "static/media/ANSO-Workshop.74a0bc73.png";